/*global window, jQuery, calendar */
(function($) {

  'use strict';

  $(function() {

    function getEventsForMonth(month) {
      // take the `month` object and use it to request the correct month
      $.ajax({
        dataType: 'json',
        type: 'POST',
        url: '/ajax/calendar.php',
        data: {
          mm: month.format('MM'),
          yy: month.format('YYYY'),
          tipo: calendar.tipo
        },
        success: function(events) {
          //console.log(events);
          clndr.setEvents(events);
          //for (event of events) {
          //    $('.calendar-day-' + event.date + ' > .day-contents').css('border-bottom', '10px solid ' + event.color);
          //    $('.calendar-day-' + event.date).css('background-color', event.colorBG);
          //};
          for (var i = 0, len = events.length; i < len; i++) { 
            var event = events[i];
            //$('.calendar-day-' + event.date + ' > .day-contents').css('border-bottom', '2px solid ' + event.color);
            $('.calendar-day-' + event.date + ' > .day-contents').css('background-color', event.colorBG);
            $('.calendar-day-' + event.date + ' > .day-contents').css('color', event.color);
            $('.calendar-day-' + event.date + ' > .day-contents').css('border-radious', '100%');
          }
        }
      });
    }

  	const getStartDate = () => {
      const today = new Date();
      return new Date(today.getFullYear(), today.getMonth(), today.getDay());
    };

    const getEndDate = () => {
      const today = new Date();
      return new Date(today.getFullYear(), today.getMonth() + 6, today.getDay());
    };

    const getCurrentEventsMonth = () => {
      var partiData = calendar.currentDate.split('-');
      if (partiData) {
        return new Date(partiData[0], partiData[1]-1, partiData[2]);
      }
      return getEndDate();
    };

    const getMonth = () => {
      const today = new Date(calendar.currentDate);
      return today.getMonth();
    };

    const getYear = () => {
      const today = new Date(calendar.currentDate);
      var partiData = calendar.currentDate.split('-');
      if (partiData) {
        return partiData[0];
      }
      return today.getYear();
    };

    moment.locale(document.documentElement.lang);

    var days = ['LUN', 'MAR', 'MER', 'GIO', 'VEN', 'SAB', 'DOM'];
    if (document.documentElement.lang == 'en') {
      days = ['MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT', 'SUN'];
    }
    var clndr = $('#mini-clndr').clndr({
      daysOfTheWeek: days,
      template: $('#template-calendar').html(),
      moment: moment,
      doneRendering: function() {
      },
      clickEvents: {
        onMonthChange: getEventsForMonth,
        click: function(target) {
          if (!target.events.length) {
          } else {
            document.location.href = target.events[0].title;
          }
          
        }
      },
      constraints: {
        startDate: getStartDate(),
        endDate: getEndDate()
      }
    });

    moment.locale('it');

    clndr.setMonth(getMonth());
    clndr.setYear(getYear());
    getEventsForMonth(moment(getCurrentEventsMonth()));

  });

}(jQuery));
